import { render } from "./ZonesTab.vue?vue&type=template&id=54b08984&scoped=true"
import script from "./ZonesTab.vue?vue&type=script&lang=js"
export * from "./ZonesTab.vue?vue&type=script&lang=js"

import "./ZonesTab.vue?vue&type=style&index=0&id=54b08984&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b08984"]])

export default __exports__